._actionItem_14qml_1 .icon-btn {
  background: none; }

._actionItem_14qml_1 .symbol-inputValidationSuccess .c1 {
  fill: white; }
